import { useDataQuery } from "@Libs/DataLayer/hooks/useDataQuery";
import { getSubscriptionProducts } from "../services/subscriptionPlans";
import { ISubscriptionPlan } from "../types";

export const useSubscriptionPlans = () => {
  const {
    data: subscriptionPlans,
    isLoading,
    isError,
    isSuccess,
    status,
  } = useDataQuery<ISubscriptionPlan[]>("subscriptionPlans", () =>
    getSubscriptionProducts()
  );

  return { subscriptionPlans, isLoading, isError, isSuccess, status };
};
